import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchApi } from '@/lib/api/client';
import { passkeyKeys } from '@/hooks/api/query-keys';
import type { StoredPasskey } from '@/lib/types/ai-chat';

// ============ Types ============

export interface PasskeyStatus {
  hasPasskeys: boolean;
  count: number;
}

// ============ Query Hooks ============

export function usePasskeys() {
  return useQuery({
    queryKey: passkeyKeys.list(),
    queryFn: () => fetchApi<StoredPasskey[]>('/auth/passkeys'),
  });
}

export function usePasskeyStatus() {
  return useQuery({
    queryKey: passkeyKeys.status(),
    queryFn: () => fetchApi<PasskeyStatus>('/auth/passkeys/status'),
  });
}

// ============ Mutation Hooks ============

export function useDeletePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      fetchApi(`/auth/passkeys/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: passkeyKeys.all });
    },
  });
}
